import React from 'react';
import { Link } from 'react-router-dom';

const PlayerAvatar = ({ player, index = 0 }) => (
  <Link
    to={`/profile/${player.playerId}`}
    key={player.playerId || index}
    style={{
      zIndex: `${index}`,
      margin: '1px',
      display: 'inline-block',
    }}
  >
    <img
      src={
        player.profilePhoto
          ? player.profilePhoto
          : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
      }
      alt={player.playerId || ''}
      title={player.playerId || ''}
      style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '1px solid #ccc',
        background: '#fff',
      }}
    />
  </Link>
);

export default PlayerAvatar;
